export const INIT = 'app/ActionPage/INIT';
export const INIT_SUCCESS = 'app/ActionPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/ActionPage/INIT_FAILED';

interface InitAction {
  type: typeof INIT;
}
interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}
interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: any;
  errorCode?: number;
}

const initAction = (id?: string) => ({
  type: INIT,
  id,
});
const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
const initFailedAction = (error: any, errorCode?: any) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export {
  InitAction,
  InitSuccessAction,
  InitFailedAction,
  initAction,
  initSuccessAction,
  initFailedAction,
};
